import {makeStyles} from "@material-ui/core/styles";
import {FORM_FIELD_HEIGHT} from "../../../../../../TransactionsMonitoring/components/Filters/components/common_styles";

export default (theme) => ({
  input: {
    display: 'none'
  },
  label: {
    position: 'relative',
    top: -8,
    display: 'flex',
    alignItems: 'center'
  },
  withError: {
    borderColor: 'red'
  },
  endAdornmentBtn: {
    position: 'absolute',
    fontFamily: 'Roboto-Bold',
    right: -1,
    top: -1,
    textTransform: 'capitalize',
    borderRadius: '0 4px 4px 0',
    boxShadow: 'none',
    minHeight: '45px !important',
    height: '45px !important',
    [theme.breakpoints.down('sm')]: {
      minHeight: '35px !important',
      height: '35px !important',
    },
  },
  fileContainer: {
    alignItems: 'center',
    flexWrap: 'nowrap',
    '&:not(.newDesign)': {
      paddingRight: 0,
      color: '#0092E5',
      backgroundColor: '#ecf8fe',
    },
    borderRadius: 4,
    position: 'relative',
    top: -8,
    borderColor: 'transparent',
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0
  },
  removeDocumentWrapper: {
    marginLeft: 'auto',

    '& .MuiIconButton-root': {
      color: 'inherit',
    },
  },
  previewLink: {
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  previewContent: {
    textAlign: 'center',
    maxHeight: '80vh',
  }
})

const btnSize = FORM_FIELD_HEIGHT - 10;

export const useNewPreviewStyles = makeStyles((theme) => ({
  extensionIcon: {
    background: '#eef0f2',
    color: '#838994',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: btnSize,
    minWidth: btnSize,
    height: btnSize,
    borderRadius: '50%',
    fontSize: btnSize * 0.6,
    marginRight: 15
  },
  deleteIcon: {
    fontSize: btnSize * 0.4,
  },
  fileName: {
    margin: 0,
    overflow: 'hidden',
    '& > :first-child': {
      fontFamily: 'Roboto-Bold',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: '100%'
    },
    '& > :last-child': {
      fontFamily: 'Roboto-Regular',
      textTransform: 'uppercase',
      color: '#838994',
      fontSize: 12,
    }
  },
  removeDocumentWrapper: {
    marginLeft: 'auto',
  },
  previewLink: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 14
  }
}));